<template>
  <div class="main">
    <van-sticky class="operation_remark" style="width:20%;right:0">
      <div @click="showOperationRemark">
        操作说明
      </div>
    </van-sticky>
    <van-tabs
      @click="selectByStatus"
      offset-top="0"
      title-active-color="#C99B54"
      color="#c99b54"
      sticky
      ref="container"
    >
      <van-tab
        v-for="(child, idx) in tabs"
        v-bind:key="idx"
        :title="child.name"
        :name="child.title"
      >
        <div
          class="orderTab"
          :style="{ height: tabHeight + 'px', color: 'red' }"
        >
          <van-pull-refresh
            v-model="refreshing"
            @refresh="onRefresh"
            style="min-height:100vh"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              offset="100"
              @load="loadData"
            >
              <van-cell-group
                :border="false"
                class="order"
                v-for="item in idx > 0 ? childs[idx - 1].list : allCustomOrders"
                v-bind:key="item.productionDemandOrderId"
              >
                <div @click="toCustomDetail(item.productionDemandOrderId)">
                  <van-cell
                    :border="false"
                    :title="'编号:' + item.pdeNum"
                    :value="statusArray[item.status]"
                    :data-id="item.productionDemandOrderId"
                    value-class="cellRed"
                  >
                  </van-cell>

                  <van-cell
                    v-if="item.printStatus != null"
                    :title="'打印状态:'"
                    value-class="cellYellow"
                    :value="printStatusArray[item.printStatus]"
                    :border="false"
                  >
                  </van-cell>
                  <van-cell
                    :title="'收货人:' + item.userName"
                    :border="false"
                  ></van-cell>

                  <van-cell
                    v-if="item.boxType == '1'"
                    center
                    :border="false"
                    title-style="display:flex;align-items:center;flex-direction:row;font-size:14px;min-width:90%"
                  >
                    <template #title>
                      <van-image
                        fit="contain"
                        height="67"
                        width="106"
                        :src="item.giftBoxPicture"
                        style="margin-right:6px"
                      />
                      <span>定制礼盒</span>
                    </template>
                  </van-cell>

                  <van-cell
                    :border="false"
                    :title-style="
                      (item.boxType == '1' ? 'margin-left:20px;' : '') +
                        'display:flex;align-items:center;flex-direction:row;font-size:14px;min-width:90%'
                    "
                    center
                    v-for="i in item.list"
                    :key="i.id"
                    :value="'x' + i.count"
                  >
                    <template #title>
                      <van-image
                        fit="contain"
                        height="47"
                        width="86"
                        :src="i.nciUrl"
                        style="margin-right:6px"
                      />
                      <span>{{ i.productName }}</span>
                    </template>
                  </van-cell>
                  <div
                    style="font-size:14px;text-align:right;color:#101010;padding:10px "
                  >
                    共{{ item.list.length }}件
                  </div>
                </div>
                <van-divider
                  v-if="item.status !== 3 && item.printStatus !== 2"
                  :style="{ margin: '0' }"
                />
                <div
                  class="btnContent"
                  v-if="item.status !== 3 && item.printStatus !== 2"
                >
                  <van-button
                    plain
                    type="default"
                    v-if="item.status != 3"
                    size="small"
                    :data-img="item.previewImgUrl"
                    @click="previewImg"
                    >打印预览</van-button
                  >

                  <van-button
                    v-if="item.status == 0"
                    plain
                    type="default"
                    size="small"
                    :data-id="item.productionDemandOrderId"
                    data-msg="无法制作"
                    :data-active="3"
                    @click="sumbitAction"
                    >无法制作</van-button
                  >
                  <van-button
                    v-if="item.status == 0"
                    type="default"
                    size="small"
                    color="#C99B54"
                    :data-active="0"
                    data-msg="开始接单"
                    :data-id="item.productionDemandOrderId"
                    @click="sumbitAction"
                    >开始接单</van-button
                  >
                  <!-- printStatus	打印状态(0:正在打印 1:已完成 2:已取消 3:打印失败 4:等待打印) -->
                  <van-button
                    v-if="item.status == 1"
                    plain
                    type="default"
                    size="small"
                    :data-active="2"
                    data-msg="完成制定"
                    :data-id="item.productionDemandOrderId"
                    @click="sumbitAction"
                    >制作完成</van-button
                  >
                  <van-button
                    v-if="item.status == 1 && item.transmissionStatus == '2'"
                    plain
                    type="default"
                    size="small"
                    :data-no="item.pdeNum"
                    @click="printCustom"
                    >定制打印</van-button
                  >
                  <van-button
                    v-if="
                      item.status == 1 &&
                        item.printStatus == 4 &&
                        item.transmissionStatus != '2'
                    "
                    plain
                    type="default"
                    size="small"
                    ><van-loading type="spinner"
                      >正在上传打印文件...</van-loading
                    >
                  </van-button>
                </div>
              </van-cell-group>
            </van-list>
          </van-pull-refresh>
          <div class="clearfloat"></div>
        </div>
      </van-tab>
    </van-tabs>
    <van-dialog
      v-model="showDialog"
      :show-cancel-button="false"
      :showConfirmButton="false"
    >
      <div class="dialog_close" @click="showOperationRemark">
        <van-icon name="cross" color="#ccc" size="20" />
      </div>
      <div class="remarks">
        <van-steps direction="vertical" :active="4" active-color="#c99b54">
          <van-step>
            <h3>接收订单</h3>
            <p>确定用户订单是否可以在本店制作生产，不可制作则点击无法制作</p>
          </van-step>
          <van-step>
            <h3>准备制作</h3>
            <p>根据接单顺序将图片依次上传至printexp</p>
          </van-step>
          <van-step>
            <h3>开始制作</h3>
            <p>在printexp点击开始打印</p>
          </van-step>
          <van-step>
            <h3>交付用户</h3>
            <p>在全卡通订单中点击打印完成</p>
          </van-step>
          <van-step>
            <h3>订单完成</h3>
          </van-step>
        </van-steps>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiPost, queryPost } from "@/api/common";
import { downloadIamge } from "@/utils/tool.js";
import { ImagePreview, Dialog, Toast } from "vant";
// 引入vant组件库
export default {
  name: "CustomOrder",
  data() {
    return {
      shopInfo: "",
      tabIndex: "全部",
      allQty: "",
      orderStatus: "",
      allCustomOrders: [], //所有定制订单
      loading: false,
      refreshing: false,
      sticky: true,
      finished: false,
      tabHeight: 0,
      childs: [
        {
          name: "待接单",
          status: 0,
          qty: "",
          list: []
        },
        {
          name: "制作中",
          status: 1,
          qty: "",
          list: []
        },
        {
          name: "已完成",
          status: 2,
          qty: "",
          list: []
        },
        {
          name: "无法制作",
          status: 3,
          qty: "",
          list: []
        },
        {
          name: "无法制作",
          status: 3,
          qty: "",
          list: []
        }
      ],
      tabs: [
        {
          status: "",
          name: "全部",
          title: "全部"
        },
        {
          name: "待接单",
          status: 0,
          title: 1
        },
        {
          name: "制作中",
          status: 1,
          title: 2
        },
        {
          name: "已完成",
          status: 2,
          title: 3
        }
      ],
      statusArray: ["待接单", "制作中", "已完成", "无法制作"],
      printStatusArray: [
        "正在打印",
        "已完成",
        "已取消",
        "打印失败",
        "等待打印",
        "打印暂停"
      ],
      timerMax: new Map(),
      showDialog: false,
      loadingText: "上传中"
    };
  },
  components: {},
  created() {
    this.loadComments();
  },
  mounted() {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.tabHeight = h - 40;
  },
  methods: {
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.loadData();
    },
    loadComments() {
      let s = sessionStorage.getItem("shopInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
    },
    getCustomOrder() {
      let _this = this;
      let url =
        "/api/productionDemandOrderController/findAllProductionDemandOrder";
      let data = {
        storeId: this.shopInfo.id,
        shopCode: this.shopInfo.shopCode,
        pageNum: 1,
        pageSize: 99
      };
      if (this.orderStatus) {
        data.status = parseInt(this.orderStatus);
      }
      apiPost(url, data).then(resp => {
        let _data = resp.data;
        let _code = _data.code;
        if (_code == "0000") {
          let orderLists = _data.data.results;
          for (let i = 0; i < orderLists.length; i++) {
            let item = orderLists[i];
            if (item.status == 1 && item.transmissionStatus != "2") {
              item.timer = setInterval(function() {
                _this.checkFileUploadFinish(item, orderLists, i);
              }, 8000);
            }
          }
          _this.setCustomDatas(orderLists);
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    setCustomDatas(data) {
      let len = data.length > 0 ? data.length : "";
      let s = this.orderStatus;
      if (s == "全部" || s == "") {
        //全部
        this.allCustomOrders = data;
        this.dataInit();
        this.allQty = len;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          this.childs[item.status].list.push(item);
        }
        for (let j = 0; j < this.childs.length; j++) {
          let leng = this.childs[j].list.length;
          this.childs[j].qty = leng > 0 ? leng : "";
        }
      } else {
        this.childs[s].list = data;
        this.childs[s].qty = len;
      }
    },
    dataInit() {
      this.childs = [
        {
          name: "待接单",
          qty: "",
          list: []
        },
        {
          name: "制作中",
          qty: "",
          list: []
        },
        {
          name: "已完成",
          qty: "",
          list: []
        },
        {
          name: "无法制作",
          qty: "",
          list: []
        }
      ];
    },
    selectByStatus(name) {
      this.orderStatus = name == "全部" ? "" : name - 1;
      this.getCustomOrder();
    },
    loadData() {
      if (this.refreshing) {
        this.dataInit();
        this.refreshing = false;
      }
      this.getCustomOrder();
      this.loading = false;
      this.finished = true;
    },
    //点击动作
    sumbitAction(e) {
      let data = e.target.dataset;
      let _this = this;
      Dialog.confirm({
        title: "提醒",
        message: "确定" + data.msg
      }).then(() => {
        _this.updateOrderStatus(data);
      });
    },
    updateOrderStatus(data) {
      let _this = this;
      let url = "/api/productionDemandOrderController/updateStatus";
      let params = {
        id: data.id,
        operateType: data.active,
        fileTransfer: data.fileTransfer
      };
      if (this.orderStatus) {
        data.status = parseInt(this.orderStatus);
      }
      if (data.msg === "开始接单") {
        this.$toast.loading({
          message: "正在将图片一次上传至printexp，请确保软件开启"
        });
      }
      apiPost(url, params).then(resp => {
        let _data = resp.data;
        let _code = _data.code;
        if (_code == "0000") {
          Toast.clear();
          _this.$toast.success("成功");
          _this.getCustomOrder();
        } else {
          Dialog.alert({
            title: "提示",
            message: _data.msg,
            theme: "round-button"
          });
        }
      });
    },
    downs(e) {
      //下载素材
      let data = e.target.dataset;
      downloadIamge(data.img, data.id);
      ImagePreview([data.img]);
      Dialog.alert({
        title: "提示",
        message: "如无下载提示,请长按图片下载"
      });
    },
    toCustomDetail: function(id) {
      this.$router.push({
        path: "customDetail",
        query: { id: id }
      });
    },
    previewImg: function(e) {
      let data = e.target.dataset;
      ImagePreview([data.img]);
    },
    showOperationRemark: function() {
      this.showDialog = !this.showDialog;
    },
    doPrint: function(data) {
      let _this = this;
      let url = "/order/productionDemandOrderController/startMaking";
      let params = {
        productionDemandOrderNo: data.no,
        confirmStatus: data.confirmStatus
      };
      _this.$toast.loading({
        duration: 0, // 持续展示 toast,永远不会关闭
        mask: true, // 整体添加一个遮罩
        message: "打印中..."
      });
      queryPost(url, params).then(resp => {
        let _data = resp.data;
        let _code = _data.code;
        if (_code == "0000") {
          _this.$toast.success();
          _this.getCustomOrder();
          _this.loadingText = "上传中";
        } else {
          _this.$toast.fail();
          let errorMsg = _data.msg;
          if (_data.msg == "Connection refused (Connection refused)") {
            errorMsg = "店铺打印机/打印软件/或打印服务未开启,请检查!";
          }
          Dialog.alert({
            title: "提示",
            message: errorMsg,
            theme: "round-button"
          });
          _this.loadingText = "上传中";
        }
      });
    },
    //定制打印
    printCustom: function(e) {
      let _this = this;
      let data = e.target.dataset;
      if (data.printting) {
        Dialog.confirm({
          title: "警告",
          message: "当前打印正在进行中,是否重新打印!"
        })
          .then(() => {
            Dialog.confirm({
              title: "提示",
              message: "请确认盒子是否摆放正确！"
            })
              .then(() => {
                _this.loadingText = "打印中";
                _this.doPrint(data);
              })
              .catch();
          })
          .catch(() => {
            // on cancel
          });
      } else {
        Dialog.confirm({
          title: "提示",
          message: "请确认盒子是否摆放正确！"
        })
          .then(() => {
            _this.loadingText = "打印中";
            _this.doPrint(data);
          })
          .catch();
      }
    },

    //检验ftp文件是否传输完成
    checkFileUploadFinish: function(data, orderList, i) {
      let _this = this;
      const timer = data.timer;
      let count = this.timerMax.get(timer);
      if (!count) {
        count = 0;
      }
      if (count >= 20) {
        console.log("定时任务执行超过20次,中止了");
        clearInterval(data.timer);
        this.timerMax.delete(timer);
        return;
      }
      count = count + 1;
      this.timerMax.set(timer, count);
      let url = "/api/productionDemandOrderController/findById";
      let params = {
        id: parseInt(data.productionDemandOrderId)
      };
      queryPost(url, params).then(resp => {
        let _data = resp.data;
        let _code = _data.code;
        console.log(_code);
        if (_code == "0000") {
          if (_data.data.results.transmissionStatus == 2) {
            orderList[i].transmissionStatus = 2;
            clearInterval(data.timer);
            _this.setCustomDatas(orderList);
          }
        }
      });
    }
  }
};
</script>
<style lang="less">
@import url("../../assets/css/customOrder.less");
</style>
